var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100",attrs:{"id":"app"}},[_c('header-progress-bar'),(_vm.loaded)?_c(_vm.layout,{tag:"component"},[_c('router-view',{key:_vm.$route.path})],1):_vm._e(),_c('login-modal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }